// -----------------------------------------------------------------------
// <copyright file="ServiceAgreement.tsx" company="Microsoft">
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

import { ITheme, Link } from '@fluentui/react';
import * as React from 'react';

import { StyledText } from '../../common/components/StyledText';
import { SMCTicketing } from '../../models/constants/getHelpConstants';
import { getOpenItNowLinkStyle, getServiceAgreementFooterStyle } from '../../self-help/styles/selfHelpStyles';
import { getString } from '../../utils/stringLoader';
import { useSelector } from 'react-redux';
import { marketSelector } from '../../../web-legacy/packages/app/selectors/contactUsSelector';

interface IProps {
  theme?: ITheme;
}

export const ServiceAgreement = (props: IProps) => {
  const culture = useSelector(marketSelector);
  return (
    <StyledText styles={getServiceAgreementFooterStyle(props.theme)}>
      {getString('GetHelp_ContactSupport_ServiceAgreementTextPart')}
      <Link target="_blank" href={SMCTicketing.ServiceAgreementLink.replace('{0}', culture)} styles={getOpenItNowLinkStyle(props.theme)}>
        {getString('GetHelp_ContactSupport_ServiceAgreementLinkPart')}
      </Link>
    </StyledText>
  );
};
